"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NanoCache = void 0;
/**
 * Nano
 *
 * Базовый кэшер на основе класса Map (ES6)
 *
 * @class Nano
 * @extends {Map}
 * @template K - тип ключа
 * @template V - тип значения в кэше
 */
class NanoCache extends Map {
    constructor(options = {}) {
        var _a;
        super();
        this._options = {
            ttl: (_a = options.ttl) !== null && _a !== void 0 ? _a : 30 * 1000,
            ttlInterval: options.ttlInterval,
            renewOnGet: !!options.renewOnGet || false
        };
        if (!this._options.ttlInterval) {
            this._options.ttlInterval = this._options.ttl;
        }
        this._interval = setInterval(() => {
            const now = Date.now();
            super.forEach((element, key) => {
                if (!element.expireAt || element.expireAt < now) {
                    this._expireKey(key);
                }
            });
        }, this._options.ttlInterval);
        // У ноды есть unref, у фронта его нет
        if (typeof this._interval.unref === 'function') {
            this._interval.unref();
        }
    }
    once(key, callback) {
        const getAndSave = () => {
            const result = callback();
            this.set(key, result);
            return result;
        };
        const result = this.get(key);
        if (result === undefined) {
            return getAndSave();
        }
        return result;
    }
    add(key, value, options = {}) {
        if (!super.has(key)) {
            return this.set(key, value, options).get(key);
        }
        return options.returnSaved ? this.get(key) : undefined;
    }
    set(key, value, options = {}) {
        const result = super.set(key, this._toCacheValue(value, options));
        return options.returnSaved ? this : result;
    }
    get(key) {
        const result = super.get(key);
        if (result === undefined) {
            return undefined;
        }
        if (this._options.renewOnGet) {
            const ttl = result.ttl || this._options.ttl;
            result.expireAt = Date.now() + ttl;
            result.ttl = ttl;
        }
        return this._fromCacheValue(result);
    }
    forEach(callback, thisArg) {
        return super.forEach(({ value }, key, map) => {
            callback.call(thisArg, value, key, map);
        });
    }
    _expireKey(key) {
        super.delete(key);
    }
    _toCacheValue(value, options = {}) {
        var _a;
        const ttl = (_a = options.ttl) !== null && _a !== void 0 ? _a : this._options.ttl;
        return {
            value,
            expireAt: Date.now() + ttl,
            ttl
        };
    }
    _fromCacheValue(value) {
        return value.value;
    }
}
exports.NanoCache = NanoCache;
//# sourceMappingURL=nano-cache.class.js.map